import { Icon } from '@iconify/react';
import { useRef, useState } from 'react';

import { Link as RouterLink } from 'react-router-dom';
import emailIcon from '@iconify/icons-eva/email-outline';
import trash2Outline from '@iconify/icons-eva/trash-2-outline';
import moreVerticalFill from '@iconify/icons-eva/more-vertical-fill';
import toggleOn from '@iconify/icons-eva/toggle-left-outline';
import toggleOff from '@iconify/icons-eva/toggle-right-outline';
// material
import { Menu, MenuItem, IconButton, ListItemIcon, ListItemText, Tooltip } from '@mui/material';

// ----------------------------------------------------------------------

export default function WWCMore({ email }) {
  const ref = useRef(null);
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Tooltip title="More">
        <IconButton ref={ref} onClick={() => setIsOpen(true)}>
          <Icon icon={moreVerticalFill} width={20} height={20} />
        </IconButton>
      </Tooltip>
      <Menu
        open={isOpen}
        anchorEl={ref.current}
        onClose={() => setIsOpen(false)}
        PaperProps={{
          sx: { width: 200, maxWidth: '100%' }
        }}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <a href={`mailto:${email}`} style={{ textDecoration: 'none' }}>
          <MenuItem sx={{ color: 'text.secondary' }}>
            <ListItemIcon>
              <Icon icon={emailIcon} width={24} height={24} />
            </ListItemIcon>
            <ListItemText primary="Contact" primaryTypographyProps={{ variant: 'body2' }} />
          </MenuItem>
        </a>
      </Menu>
    </>
  );
}
